import SlimSelect from 'slim-select';

class MarketSwitch {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-marketswitch',
            selectAttr: 'select',
            filledClassname: 'is--filled',
            focusedClassname: 'is--focused',
            errorClassname: 'has--error'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$marketSwitch = $element;

        this.$marketSwitchForm = this.$marketSwitch.querySelector('form');
        this.$marketSwitchSelect = this.$marketSwitch.querySelector('[' + this.settings.initAttr + '="' + this.settings.selectAttr + '"]');

        this.initialize();
    }

    initialize () {
        if (this.$marketSwitchForm && this.$marketSwitchSelect) {
            this.initSelect(this.$marketSwitchSelect);
            this.initForm(this.$marketSwitchForm);
        }
    }

    initSelect ($element) {
        const $field = $element.querySelector('select');
        const fieldAPI = new SlimSelect({
            allowDeselectOption: false,
            select: $field,
            placeholder: false,
            showSearch: false,
            showContent: 'auto',
            closeOnSelect: true,
            beforeOpen: () => {
                $element.classList.add(this.settings.focusedClassname);
            },
            beforeClose: () => {
                $element.classList.remove(this.settings.focusedClassname);
            }
        });

        $element.fieldAPI = fieldAPI;
    }

    initForm ($form) {
        $form.addEventListener('submit', (e) => {
            const locale = this.$marketSwitchSelect.querySelector('select').value;
            const uri = $form.getAttribute('action') + locale;

            this.handleUri(uri);

            e.preventDefault();
        });
    }

    handleUri (uri) {
        window.location.href = uri;
    }
}

export { MarketSwitch };
